// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as CatalogRoutes from "./CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query variant($id: ID!)  {\nvariant(id: $id)  {\n__typename  \ncku  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variant;
  return {
    variant: !(value$1 == null) ? ({
        __typename: value$1.__typename,
        cku: Scalar.CKU.parse(value$1.cku)
      }) : undefined
  };
}

function serialize(value) {
  let value$1 = value.variant;
  let variant;
  if (value$1 !== undefined) {
    let value$2 = value$1.cku;
    let value$3 = Scalar.CKU.serialize(value$2);
    let value$4 = value$1.__typename;
    variant = {
      __typename: value$4,
      cku: value$3
    };
  } else {
    variant = null;
  }
  return {
    variant: variant
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let useLazy = include.useLazy;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function CatalogVariantByIdPage(props) {
  let id = props.id;
  let navigate = Navigation.useNavigate();
  let activeShop = Auth.useActiveShop();
  let activeShopId = Stdlib_Option.map(activeShop, shop => shop.id);
  let match = useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  React.useEffect(() => {
    executeQuery(undefined, undefined, {
      id: id
    });
  }, [activeShopId]);
  if (queryResults.TAG !== "Executed") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  let match$1 = queryResults._0;
  let match$2 = match$1.data;
  if (match$2 !== undefined) {
    let variant = match$2.variant;
    if (variant !== undefined) {
      navigate({
        replace: true
      }, CatalogRoutes.variantRoute(variant.cku));
      return null;
    }
  }
  if (match$1.loading) {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  } else {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
}

let make = React.memo(CatalogVariantByIdPage);

export {
  Query,
  make,
}
/* query Not a pure module */
